import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";
import { AssistantActivity } from "../AssistantActivity";

const MONA_STEPS = [
  "Read the dataset columns",
  "Asked which column defines the groups",
  "Proposed: Compare block by group",
  "Proposed: box plot by group",
];

const POINTS = [
  { title: "Plain English in.", body: "Describe the analysis and Mona builds the flow, or changes the one you have." },
  { title: "You approve every change.", body: "Mona proposes; you accept or reject. Nothing changes without your say-so." },
  { title: "She asks when it matters.", body: "If a request is ambiguous, Mona asks a clarifying question instead of guessing." },
  { title: "Ask Mona to fix.", body: "When a block errors, one click hands her the error to resolve." },
];

export function MeetMona() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref} className="grid lg:grid-cols-2 gap-14 items-center">
      <motion.div style={{ y: fgY }}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0284C7] dark:text-[#38BDF8] mb-3">Flow · AI Assistant</p>
        <h3 className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white mb-8">Meet Mona.</h3>
        <div className="space-y-5">
          {POINTS.map(({ title, body }) => (
            <div key={title}>
              <p className="text-sm font-medium text-[#0A0A0F] dark:text-white">{title}</p>
              <p className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] mt-1">{body}</p>
            </div>
          ))}
        </div>
      </motion.div>
      <motion.div style={{ y: bgY }}>
        <AssistantActivity
          name="Mona" status="Proposing" accentCls="text-[#0284C7] dark:text-[#38BDF8]"
          prompt="Compare outcomes across groups and chart the difference."
          steps={MONA_STEPS}
          trailing="Waiting for your approval..."
        />
      </motion.div>
    </div>
  );
}
